import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ChangeEvent, useState } from "react";
import styled from "styled-components";
import usePutDetect from "../hooks/usePutDetect";
import theme from "../theme";
import { DetectTodayResult, GetMobilityLive } from "../types/types";
import userStorage from "../utils/userStorage";
import { Button } from "./common/Button";
import { useWindowSize } from "@reactuses/core";

const { md } = theme.screen;

// 전복사고 감지 해제 사유 모달
const WriteReasonModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
  title: string;
  content: string;
  confirmText: string;
  icon: JSX.Element;
  data: GetMobilityLive | DetectTodayResult;
  setSelect: any;
}> = (props) => {
  const {
    icon,
    open,
    onPressNo,
    title,
    content,
    confirmText,
    data,
    setSelect,
  } = props;
  const { width } = useWindowSize();
  const [value, setValue] = useState("119 출동 완료");
  const [direct, setDirect] = useState("");
  const user = userStorage.get();

  const { mutate: patchDetect, isPaused } = usePutDetect({
    checker_name: user?.name as string,
    header_seq: data.accident_header_seq as number,
    pid: data.device_pid,
    reason: direct ? direct : value,
    afterPatched: onPressNo,
    afterPatched2: setSelect,
  });

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
    setDirect("");
  };

  const onDirectChange = (e: ChangeEvent<HTMLInputElement>) => {
    setDirect(e.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={onPressNo}
      PaperProps={{
        sx: {
          width: width <= md ? "400px" : "513px",
          maxWidth: width <= md ? "400px" : "513px",
          minWidth: width <= md ? "320px" : "513px",
          minHeight: width <= md ? "300px" : "454px",
          maxHeight: width <= md ? "500px" : "650px",
          alignItems: "center",
          pt: width <= md ? "40px" : "50px",
          borderRadius: "20px",
          pb: width <= md ? "40px" : "65px",
        },
      }}
    >
      {icon}
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: width <= md ? "14px" : "20px",
          lineHeight: width <= md ? "17px" : "23px",
          mt: width <= md ? "10px" : "14px",
          mb: width <= md ? "10px" : "15px",
          padding: width <= md ? "10px 15px" : "16px 24px",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "0px",
        }}
      >
        <DialogContentText
          sx={{
            width: {
              xs: "100%",
              sm: "100%",
            },
            marginX: {
              xs: "auto",
            },
            fontWeight: 400,
            fontSize: width <= md ? "12px" : "15px",
            lineHeight: "18px",
            color: theme.color.neutral_600,
            whiteSpace: "pre-line",
            textAlign: "center",
          }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          if (patchDetect) {
            patchDetect();
          }
        }}
      >
        <Select
          //placeholder="감지 해제 사유를 선택해주세요."
          sx={{
            height: width <= md ? "24px" : "56px",
            fontSize: width <= md ? "12px" : "15px",
            width: width <= md ? "100%" : "330px",
            textAlign: "center",
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: theme.color.neutral_300,
            },
            ".MuiSelect-select": {
              backgroundColor: theme.color.white,
              borderRadius: "3px",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.color.neutral_200,
            },
          }}
          value={value}
          onChange={handleChange}
          inputProps={{
            MenuProps: {
              MenuListProps: {
                sx: {
                  maxHeight: 382,
                  overflowY: "auto",
                  backgroundColor: theme.color.white,
                  color: theme.color.neutral_500,
                  ".MuiMenuItem-root": {
                    height: width > md ? "48px" : "30px",
                    minHeight: width > md ? "48px" : "30px",
                    fontSize:
                      width > md
                        ? theme.fontSize.BOTTOM_SHEET_1
                        : theme.fontSize.FONT_2,
                  },
                },
              },
            },
          }}
        >
          <MenuItem
            // sx={{ fontSize: width <= md ? "12px" : "16px" }}
            value={`119 출동 완료`}
          >
            119 출동 완료
          </MenuItem>
          <MenuItem
            // sx={{ fontSize: width <= md ? "12px" : "16px" }}
            value={`농기계 센터 입고 처리 완료`}
          >
            농기계 센터 입고 처리 완료
          </MenuItem>
          <MenuItem
            // sx={{ fontSize: width <= md ? "12px" : "16px" }}
            value={`사고 미발생 확인 완료`}
          >
            사고 미발생 확인 완료
          </MenuItem>
          <MenuItem
            // sx={{ fontSize: width <= md ? "12px" : "16px" }}
            value={`직접 입력`}
          >
            기타 (직접 입력)
          </MenuItem>
        </Select>
        {value === "직접 입력" && (
          <CustomInput
            maxLength={20}
            value={direct}
            placeholder="상세 사유를 입력해주세요 (20자 이내)"
            onChange={onDirectChange}
          />
        )}
        <BtnWrapper>
          <Button
            bgColor={theme.statusColor.MAIN}
            hoverColor={theme.statusColor.MAIN_HOVER}
            disabled={value === "직접 입력" && direct.length === 0}
            type="submit"
            isLoading={isPaused}
          >
            {confirmText}
          </Button>
          <Button
            bgColor={theme.statusColor.CLOSE}
            hoverColor={theme.statusColor.CLOSE_HOVER}
            type="button"
            onClick={onPressNo}
          >
            취소
          </Button>
        </BtnWrapper>
      </Form>
    </Dialog>
  );
};

const CustomInput = styled.input`
  width: 330px;
  border: 1px solid ${theme.color.neutral_300};
  border-radius: 3px;
  padding-left: 20px;
  height: 54px;

  @media (max-width: ${theme.screen.md}px) {
    width: 100%;
    height: 30px;
    font-size: 12px;
  }
`;

const BtnWrapper = styled.div`
  button {
    margin: 0px;
    width: 330px;
    height: 54px;
  }
  @media (max-width: ${md}px) {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;

    button {
      width: 100%;
      font-size: 12px;
      height: 30px;
      gap: 15px;
    }
  }
  @media (min-width: ${md + 1}px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
`;

const Form = styled.form`
  @media (max-width: ${md}px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 30px 10px 30px;
    gap: 15px;
  }
  @media (min-width: ${md + 1}px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 30px 10px 30px;
    gap: 20px;
  }
`;

export default WriteReasonModal;
